"use client";

/**
 * Diagrama "Arquitetura Seraik" nativo (substitui o SVG estatico claro que
 * destoava no dark e sumia no light). 3 camadas: Fontes -> Camada Seraik ->
 * Pessoas/Decisao. Paleta da marca, temavel (bg-card/border/foreground), funciona
 * em claro e escuro. Nomes reais do squad.
 */

const FONTES = ["GA4", "Adobe Analytics", "Google Ads", "Meta Ads", "BigQuery", "CRM (HubSpot/RD)", "Excel / CSV", "Sheets / SFTP"];
const CAMADA = [
  { t: "Aggregator", s: "consolida as fontes" },
  { t: "Squad", s: "Mayra · Sofia · José · Lucas · Elena" },
  { t: "Mesa", s: "investigação multi-fonte" },
  { t: "Painel", s: "Executivo · 89 cards" },
];
const PESSOAS = ["CMO", "Head de Performance", "CRO / UX", "Direção"];

function Chip({ children }: { children: React.ReactNode }) {
  return <div className="rounded-lg border border-border bg-card px-3 py-2 text-center text-[13px] font-medium text-foreground">{children}</div>;
}
function Arrows() {
  return (
    <div className="flex justify-center gap-16 my-3 text-muted-foreground/50" aria-hidden="true">
      {[0, 1, 2].map((i) => <span key={i} className="text-lg leading-none">↓</span>)}
    </div>
  );
}

export function ArchitectureDiagram() {
  return (
    <div className="w-full max-w-3xl mx-auto rounded-2xl border border-border bg-card/60 p-5 shadow-sm">
      <h3 className="text-center text-lg font-bold text-foreground mb-4">Arquitetura Seraik</h3>

      <div className="rounded-xl border border-border/70 bg-muted/20 p-3">
        <p className="text-[10px] uppercase tracking-widest font-semibold text-muted-foreground mb-2">Fontes de dados</p>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">{FONTES.map((f) => <Chip key={f}>{f}</Chip>)}</div>
      </div>

      <Arrows />

      <div className="rounded-xl border p-3" style={{ borderColor: "rgba(123,92,255,.4)", background: "linear-gradient(180deg,rgba(20,180,249,.06),rgba(210,15,253,.06))" }}>
        <p className="text-[10px] uppercase tracking-widest font-semibold mb-2" style={{ color: "#7b5cff" }}>Camada Seraik</p>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
          {CAMADA.map((c) => (
            <div key={c.t} className="rounded-lg border border-violet-500/30 bg-card px-3 py-2.5 text-center">
              <div className="text-[13px] font-bold text-foreground">{c.t}</div>
              <div className="text-[10px] text-muted-foreground mt-0.5 leading-tight">{c.s}</div>
            </div>
          ))}
        </div>
      </div>

      <Arrows />

      <div className="rounded-xl border p-3" style={{ borderColor: "rgba(20,180,249,.4)", background: "rgba(20,180,249,.05)" }}>
        <p className="text-[10px] uppercase tracking-widest font-semibold mb-2" style={{ color: "#14b4f9" }}>Pessoas · Decisão</p>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">{PESSOAS.map((p) => <Chip key={p}>{p}</Chip>)}</div>
      </div>
    </div>
  );
}
